import moment from "moment";

export const getStartDate = (timings, availableDate) => {
    const today = moment().startOf("day");
    const available = moment(availableDate).startOf("day");
    const finalDate = available.isAfter(today) ? available : today;
    const todayWeekday = finalDate.isoWeekday();

    const dayMap = { SUN: 7, MON: 1, TUE: 2, WED: 3, THUR: 4, FRI: 5, SAT: 6 };

    const sortedTimings = [...timings]?.sort((a, b) =>
        dayMap[a.classDay] - dayMap[b.classDay]
    );

    const rotatedTimings = [
        ...sortedTimings.filter(t => dayMap[t.classDay] >= todayWeekday),
        ...sortedTimings.filter(t => dayMap[t.classDay] < todayWeekday)
    ];

    let selectedForThisWeek = rotatedTimings.find(t => {
        return (
            t.isSelected
            // dayMap[t.classDay] >= todayWeekday
        );
    });

    // if (!selectedForThisWeek) {
    //     selectedForThisWeek = sortedTimings.find(t => t.isSelected);
    // }

    const finalTiming = selectedForThisWeek || rotatedTimings[0];

    const targetDay = dayMap[finalTiming?.classDay || "MON"];
    let result = finalDate.clone().isoWeekday(targetDay);

    if (result.isBefore(finalDate, "day")) {
        result.add(1, "week");
    }

    return result;
};
